export const ACTIVITY_BOARD_PERMISSION_CODES = {
  admin: 'get-activity-board-permissions-admin',
  user: 'get-activity-board-permissions-user',
} as const;

export const canReadActivityBoardPermissions = (permissionCodes: readonly string[]): boolean =>
  permissionCodes.includes(ACTIVITY_BOARD_PERMISSION_CODES.admin) ||
  permissionCodes.includes(ACTIVITY_BOARD_PERMISSION_CODES.user);

export const canViewActivityBoardPermissionReports = (permissionCodes: readonly string[]): boolean =>
  permissionCodes.includes(ACTIVITY_BOARD_PERMISSION_CODES.admin);
